import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actionsCreators from "actions/articles";
import PageBox from "../public/index";
import {Link} from 'react-router-dom'
import { Row, Col, Breadcrumb, List} from "antd";
import RightNews from './right'
// import { HomeOutlined } from "@ant-design/icons";
class HotNews extends Component {

  componentDidMount() {
    let {id}=this.props.match.params;
    this.props.lst({id});
  }

  render() {
    let { articleLst } = this.props.article;
    return (
      <PageBox>
        <Breadcrumb style={{ paddingTop: 20 }}>
          <Breadcrumb.Item>
            <a href="/">首页</a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/learn">频道</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            文章列表
          </Breadcrumb.Item>
        </Breadcrumb>
        <Row gutter={16} style={{ marginTop: 15 }}>
          <Col md={17} xs={24}>
            <div className="main">
              {articleLst ?
              <List
              dataSource={articleLst}
              pagination={{
                pageSize: 10
              }}
              renderItem={item => (
                <List.Item>
                  <Link
                    to={`/article/${item.article_id}`}
                    className="articleItem"
                  >
                    <div className="articleTitle">
                      {item.article_thumb ? (
                        <img
                          src={item.article_thumb}
                          alt="图片"
                        />
                      ) : (
                          <img
                            src={require('common/img/nopic.png')}
                            alt="图片"
                          />
                        )}
                      <div>
                      <div className="articleTitle">{item.article_title}</div>
                      <div className="articleDesp">{item.article_desp}</div>
                      </div>
                    </div>
                  </Link>
                </List.Item>
              )}
            />
              :null}
              </div>
          </Col>
          <Col md={7} xs={24}>
            <RightNews />
          </Col>
        </Row>
      </PageBox>
    );
  }
}

export default connect(
  state => state,
  dispatch => bindActionCreators(actionsCreators, dispatch)
)(HotNews);
